module.exports = __webpack_public_path__ + "img/playbutton5.2710f1a9.png";